// extracted by mini-css-extract-plugin
export default {"marquee":"RollingText_marquee__nt+-S","marqueeChildrenWrapper":"RollingText_marqueeChildrenWrapper__8V8m5","m":"RollingText_m__aG+fR"};